export default __webpack_public_path__ + "static/media/landing.5fc48c77.svg";